<template>
  <transition name="slide">
    <div
      v-if="showSidebar"
      class="sidebar-wrapper"
    >
      <div class="menu-title">
        Main Menu
      </div>
      <router-link
        v-slot="{ href, navigate, isActive }"
        to="/events"
      >
        <a
          :href="href"
          class="sidebar-btn"
          :class="{active:isActive}"
          @click="navigate"
        >
          <i class="fa fa-calendar-alt" />
          <span>Events</span>
        </a>
      </router-link>
      <router-link
        v-slot="{ href, navigate, isActive }"
        to="/drivers"
      >
        <a
          :href="href"
          class="sidebar-btn"
          :class="{active:isActive}"
          @click="navigate"
        >
          <i class="fa fa-address-card" />
          <span>Drivers</span>
        </a>
      </router-link>
      <router-link
        v-slot="{ href, navigate, isActive }"
        to="/addresses"
      >
        <a
          :href="href"
          class="sidebar-btn"
          :class="{active:isActive}"
          @click="navigate"
        >
          <i class="fa fa-map-marked-alt" />
          <span>Addresses</span>
        </a>
      </router-link>
      <router-link
        v-slot="{ href, navigate, isActive }"
        to="/reporting"
      >
        <a
          :href="href"
          class="sidebar-btn"
          :class="{active:isActive}"
          @click="navigate"
        >
          <i class="fa fa-chart-bar" />
          <span>Reporting</span>
        </a>
      </router-link>
      <router-link
        v-if="isAdmin"
        v-slot="{ href, navigate, isActive }"
        to="/users"
      >
        <a
          :href="href"
          class="sidebar-btn"
          :class="{active:isActive}"
          @click="navigate"
        >
          <i class="fa fa-users" />
          <span>Users</span>
        </a>
      </router-link>
      <div />
    </div>
  </transition>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: "Sidebar",
    computed: {
      ...mapGetters(['showSidebar','currentUser']),
      isAdmin:function(){
        return this.currentUser.role.includes('Administrator');
      }
    },
    watch: {
      '$route' () {
        this.close();
      },
    },
    methods:{
      close(){
        if (this.showSidebar){
          this.$store.dispatch('toggleSidebar')
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/variables.scss";

  .sidebar-wrapper {
    position: absolute;
    z-index: 9999;
    top: 56px;
    height: calc(100% - 56px);
    background-color: $dark-grey;
    padding: 12px 48px 12px 48px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-top: solid $bet-green 1px;
  }

  .menu-title {
    color: $white;
    font-weight: bold;
    padding-top: 6px;
    padding-bottom: 12px;
  }

  .sidebar-btn {
    padding-top: 12px;
    padding-bottom: 12px;
    display: flex;
    justify-content: flex-start;

    i {
      margin-right: 8px;
      color: $white;
      transition: 0.5s;
    }

    span {
      margin-top: -4px;
      color: $white;
      transition: 0.5s;
    }

    &:hover, &.active {
      text-decoration: none;

      i {
        color: $bet-green;
      }

      span {
        color: $bet-green;
      }
    }
  }

  .slide-enter-active, .slide-leave-active {
    transition: transform .5s;
  }

  .slide-enter, .slide-leave-to {
    transform: translate(-100%, 0);
  }
</style>